import GravityBulkAdapter from 'teacher-ui-client/adapters/gravity/bulk-adapter'
import { service } from '@ember/service'
import { assert } from '@ember/debug'
import { join } from 'teacher-ui-client/utils/uri'
import type SessionService from 'teacher-ui-client/services/session'

export default class SchoolClassAdapter extends GravityBulkAdapter {
  @service session!: SessionService

  urlForQuery() {
    const { currentSchool } = this.session

    assert('currentSchool.id missing', currentSchool?.id)

    return join(this.host, this.namespace, `schools/${currentSchool.id}/school-classes`).toString()
  }
}
